/**
 * Route for `payout-hold`. Registered via createRoute; root wires into
 * router.tsx post-merge. Breadcrumb label: "Payout Hold".
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "./__root";
import { PayoutHoldPage } from "../features/payout-hold/PayoutHoldPage";

export const payoutHoldRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/payout-hold",
	component: PayoutHoldPage,
});

export default payoutHoldRoute;
